export enum IBookingStatus {
  draft = 'drafting',
  negotiation = 'negotiating',
  reserved = 'reserved',
  canceled = 'canceled',
  ongoing = 'ongoing',
  completed = 'completed',
}
